/*
  저장소 키
*/

/**
 * 아이디
 */
export const USER_ID = 'USER_ID'

/**
 * 패스워드
 */
export const USER_PASSWORD = 'USER_PASSWORD'

/**
 * 아이디 저장
 */
export const IS_ID_SAVE = 'IS_ID_SAVE'

/**
 * 자동 로그인 여부
 */
export const IS_AUTO_LOGIN = 'IS_AUTO_LOGIN'
/**
 * 디바이스 아이디
 */
export const DEVICE_ID = 'DEVICE_ID'

/**
 * 로그인 토큰
 */
export const LOGIN_TOKEN = 'LOGIN_TOKEN'

/**
 * 최근 메뉴
 */
export const RECENT_MENU = 'RECENT_MENU'

/**
 * 마이 메뉴
 */
export const MY_MENU = 'MY_MENU'

/**
 * 전체 메뉴
 */

export const RAW_MENU = 'RAW_MENU'

/**
 * 메뉴
 */
export const MENU = 'MENU'

/**
 * 상품평 토큰
 */
export const EXT_TOKEN = 'EXT_TOKEN'
